export default {
  data () {
    return {
      dialog: {
        title: "", // 弹窗标题
        component: null, // 弹窗内嵌组件
        visible: false, // 是否显示
        width: "50%", // 弹窗宽度
        top: "15vh", // 弹窗top
        // todo 更多设置
      },
    };
  },
  methods: {
    /**
     * 显示弹窗
     * @param title String 弹窗标题
     * @param component 窗体内容组件
     * @param width 弹窗宽度
     */
    showDialog (title = "", component = null, width = "50%") {
      this.dialog = {
        visible: true,
        component,
        width,
        title,
      };
    },
    /**
     * 关闭弹窗
     */
    hideDialog () {
      this.dialog.visible = false;
    },
    /**
     * 销毁组件
     */
    destroyComponent () {
      this.dialog.component = null;
    },
    /**
     * 弹窗方法 todo 更多配置参数 动态参数处理
     * @param visible <Boolean> 是否显示
     * @param title String 弹窗标题
     * @param component <VNode> 窗体内容组件
     * @param width String 弹窗宽度
     * @param top String 弹窗top
     */
    setDialog (visible = false, title = "", component = null, width = "50%", top = "15vh") {
      if (visible) {
        this.dialog = {
          visible, title, component, width, top,
        };
      } else {
        this.dialog = { ...this.dialog, visible };
        // 动画延迟
        setTimeout(() => {
          this.dialog = {
            ...this.dialog, component, width, title,
          };
        }, 300);
      }
    },
  },
};
